import { C } from "../../shared/theme";
import { PHASE_LABELS } from "./addToPhase";

// "In Morning": the part of today a task is already planned for. Today's "+ Add task" sheet and Radar
// show it the same way.
export function PhaseBadge({ phaseId, style }) {
  return (
    <span style={{ display: "inline-block", fontSize: 12, fontWeight: 700, padding: "2px 8px", borderRadius: 100, background: C.surface2, color: C.textMid, ...style }}>
      In {PHASE_LABELS[phaseId]}
    </span>
  );
}
